import { LeadPageType } from 'enums/leadPageTypes';
import { leadLazyLoad } from 'utils/loadable';

export const TimeEntryPage = leadLazyLoad(
  () => import('./TimeEntryPage'),
  module => module.TimeEntryPage,
  { fallback: null, type: LeadPageType.TIME_AND_PAY },
);
